import { useCallback, useState } from 'react'
import { FiTrash2 } from 'react-icons/fi'

import { DeletePersonalTrainerModal } from './DeletePersonalTrainerModal'

export const DeletePersonalTrainerButton: React.FC = () => {
  const [showModal, setShowModal] = useState<boolean>(false)

  const handleOpenModal = useCallback(() => {
    setShowModal(true)
  }, [])

  const handleCloseModal = useCallback(() => {
    setShowModal(false)
  }, [])

  return (
    <>
      <button
        className='flex items-center justify-center gap-2 py-2 px-4 rounded-md
          bg-gpa-red hover:bg-red-500 text-white'
        onClick={handleOpenModal}
      >
        <span>Deletar personal trainer</span>
        <FiTrash2 size={18} />
      </button>
      <DeletePersonalTrainerModal
        visible={showModal}
        onDismiss={handleCloseModal}
      />
    </>
  )
}
